  (function() {
    var CLOSE_DELAY = 150;
    var closeTimer;

    function items() {
      return document.querySelectorAll('#ds-header2-nav [data-ds-mm2-item]');
    }

    function setOpen(item, open) {
      var trigger = item.querySelector('[data-ds-mm2-trigger]');
      if (!trigger) return;
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      items().forEach(function(item) {
        if (item !== except) setOpen(item, false);
      });
    }

    function open(item) {
      clearTimeout(closeTimer);
      closeAll(item);
      setOpen(item, true);
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function() { closeAll(); }, CLOSE_DELAY);
    }

    function bind(nav) {
      nav.querySelectorAll('[data-ds-mm2-item]').forEach(function(item) {
        var trigger = item.querySelector('[data-ds-mm2-trigger]');

        item.addEventListener('mouseenter', function() {
          if (trigger) {
            open(item);
          } else {
            closeAll();
          }
        });
        item.addEventListener('mouseleave', scheduleClose);

        if (!trigger) return;

        // Triggers are links that navigate on click; keyboard focus opens their dropdown
        trigger.addEventListener('focus', function() { open(item); });

        item.addEventListener('keydown', function(event) {
          if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
          setOpen(item, false);
          trigger.focus();
        });

        item.addEventListener('focusout', function(event) {
          if (!item.contains(event.relatedTarget)) setOpen(item, false);
        });
      });
    }

    // Clone the desktop nav into header-2's slot. Safe to call again after theme editor reloads.
    function mount() {
      var slot = document.getElementById('ds-header2-nav');
      var template = document.getElementById('ds-mm2-nav-template');
      if (!slot || !template) return;
      slot.replaceChildren(template.content.cloneNode(true));
      bind(slot);
    }

    mount();

    if (!window.dsMegaMenu2Bound) {
      window.dsMegaMenu2Bound = true;

      document.addEventListener('click', function(event) {
        if (!event.target.closest('#ds-header2-nav')) closeAll();
      });

      // Theme editor: re-mount when either section reloads; open the matching panel while editing a block
      document.addEventListener('shopify:section:load', mount);
      document.addEventListener('shopify:block:select', function(event) {
        if (!event.target.closest('[data-ds-mm2-panel]') && !event.target.closest('.shopify-section-mega-menu-2')) return;
        var isAbout = event.target.closest('.ds-mm2-links');
        var panel = document.querySelector('#ds-header2-nav [data-ds-mm2-panel="' + (isAbout ? 'about_link' : 'product') + '"]');
        if (panel) open(panel.closest('[data-ds-mm2-item]'));
      });
      document.addEventListener('shopify:section:deselect', function() { closeAll(); });
    }
  })();